import accountReducer from '../pages/MyAccounts/reducers';

export default accountReducer;
